import { genPopulateAttr } from '@utils/util';

export const aboutAppAttributes = (): string => {
  const attributes = [
    ['cover'],
    ['info_cards', 'regular_cards', 'image'],
    ['info_cards', 'regular_cards', 'link'],
  ];
  return attributes.map(it => genPopulateAttr(it)).join('&');
};
